<template>
  <BfAccordion :title="t('setup.parts.saddle')">
    <template #header-right>
      <BfButton
        :type="ButtonType.Outlined"
        @click.stop="
          router.push({
            name:
              router.currentRoute.value.meta.step === 2
                ? 'saddleSelection'
                : 'saddleUpdate',
          })
        "
      >
        {{ t('common.change') }}
      </BfButton>
      <BfBadge
        :color="
          selectedMeasurement?.saddle.active !== undefined
            ? Colors.Success
            : Colors.Danger
        "
      />
    </template>
    <BfDescriptionList :label="t('setup.saddle.model')">
      {{
        selectedMeasurement?.saddle.active
          ? `${selectedMeasurement?.saddle.active.SADDLE_BRAND} ${selectedMeasurement?.saddle.active.SADDLE_MODEL}`
          : '-'
      }}
    </BfDescriptionList>
    <BfDescriptionList :label="t('setup.saddle.width')">
      {{
        selectedMeasurement?.saddle.active
          ? `${selectedMeasurement?.saddle.active.SADDLE_WIDTH} ${t('common.unit.mm')}`
          : '-'
      }}
    </BfDescriptionList>
    <BfDescriptionList :label="t('setup.saddle.shape.index')">
      {{
        selectedMeasurement?.saddle.active
          ? selectedMeasurement?.saddle.active.SHAPE
          : '-'
      }}
    </BfDescriptionList>
    <BfDescriptionList :label="t('setup.saddle.anatomical')">
      {{
        selectedMeasurement?.saddle.active
          ? selectedMeasurement?.saddle.active.ANATOMIC_DESIGN
            ? t('common.yes')
            : t('common.no')
          : '-'
      }}
    </BfDescriptionList>
  </BfAccordion>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useMeasurementStore } from '@/store/measurementStore'
import {
  Colors,
  ButtonType,
  BfBadge,
  BfAccordion,
  BfButton,
  BfDescriptionList,
} from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const router = useRouter()
const measurementStore = useMeasurementStore()
const { selectedMeasurement } = storeToRefs(measurementStore)
</script>

<style lang="scss"></style>
